export default (function() {

    function degreesToRadians(degrees){
        let pi = Math.PI;
        return degrees * (pi/180);
    }

    function radiansToDegrees(radians){
        var pi = Math.PI;
        return radians * (180/pi);
    }

    function orthographic(lon, lat, radius){
        lon = -lon * (Math.PI / 180); 
        lat = (90 - lat) * (Math.PI / 180);
        return [radius * Math.cos(lon) * Math.sin(lat), radius * Math.cos(lat), radius * Math.sin(lon) * Math.sin(lat)];
    }
    
    /*
    *   calculate Lambert Conformal Conic Projection Parameters
    */
    function calculateLCCParams(earth_radius, par1, par2, lat0, lon0, falseEasting, falseNorthing) {
        let lat0r = degreesToRadians(lat0);
        let lon0r = degreesToRadians(lon0);
        let n = 0;
        let par1r = degreesToRadians(par1);
        let par2r = degreesToRadians(par2);
        let t1 = Math.tan(0.7853981633974483 + par1r / 2.0);
        let t2 = Math.tan(0.7853981633974483 + par2r / 2.0);

        if (Math.abs(par2 - par1) < 1.0E-6) {
            n = Math.sin(par1r);
        } else {
            n = Math.log(Math.cos(par1r) / Math.cos(par2r)) / Math.log(t2 / t1);
        }

        let t1n = Math.pow(t1, n);
        let F = Math.cos(par1r) * t1n / n;
        let earthRadiusTimesF = earth_radius * F;
        let t0n = Math.pow(Math.tan(0.7853981633974483 + lat0r / 2.0), n);
        let rho = earthRadiusTimesF / t0n;
        let lon0Degrees = radiansToDegrees(lon0r);

        return {
            n: n,
            F: F,
            earthRadiusTimesF: earthRadiusTimesF,
            earth_radius: earth_radius,
            t0n: t0n,
            rho: rho,
            lon0Degrees: lon0Degrees,
            lon0: lon0r,
            lat0: lat0r,
            falseEasting: falseEasting,
            falseNorthing: falseNorthing,
        }
    }

    /*
    *   invert x, y points to Lambert Conformal Conic Projection Lon, Lat Coords
    *   x, y points are relative point from center with unit length
    */
    function lambertConformalConicInvert(params, x, y){
        let fromX = x - params.falseEasting;
        let fromY = y - params.falseNorthing;
        let rhop = params.rho;
        if (params.n < 0.0) {
            rhop *= -1.0;
            fromX *= -1.0;
            fromY *= -1.0;
        }

        let yd = rhop - fromY;
        let theta = Math.atan2(fromX, yd);
        let r = Math.sqrt(fromX * fromX + yd * yd);
        if (params.n < 0.0) {
            r *= -1.0;
        }

        let toLon = radiansToDegrees(theta / params.n + params.lon0);
        let toLat;
        if (Math.abs(r) < 1.0E-6) {
            toLat = params.n < 0.0 ? -90.0 : 90.0;
        } else {
            let rn = Math.pow(params.earth_radius * params.F / r, 1.0 / params.n);
            toLat = radiansToDegrees(2.0 * Math.atan(rn) - 1.5707963267948966);
        }

        return [toLon, toLat]
    }

    function calculateLCCCoords(dx, dy, x0, y0, nx, ny, earth_radius, p1, p2, la0, lo0){
        const falseEasting = 0.;
        const falseNorthing = 0.;
        let params = calculateLCCParams(earth_radius, p1, p2, la0, lo0, falseEasting, falseNorthing);
        let coords = [], ix = 0;

        for(let y = 0; y < ny; y++){
            for(let x = 0; x < nx; x++){
                coords[ix++] = lambertConformalConicInvert(
                    params,
                    x0 + x * dx, 
                    y0 - y * dy
                );
            }
        }

        return coords;
    }

    return {
        orthographic: orthographic,
        calculateLCCParams: calculateLCCParams,
        lambertConformalConicInvert: lambertConformalConicInvert,
        calculateLCCCoords: calculateLCCCoords,
        degreesToRadians: degreesToRadians,
        radiansToDegrees: radiansToDegrees,
    };

})();